// extracted by mini-css-extract-plugin
export default {"pageWrap":"Wa-z","fullWidth":"Xa-z","heading":"Ya-z","fullBleed":"Za-z","hidden":"_a-z"};